function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 14,
  fill: "#BDE8E5"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 17.4997V19.9997H10.5L17.8733 12.6264L15.3733 10.1264L8 17.4997ZM19.8067 10.693C20.0667 10.433 20.0667 10.013 19.8067 9.75305L18.2467 8.19305C17.9867 7.93305 17.5667 7.93305 17.3067 8.19305L16.0867 9.41305L18.5867 11.913L19.8067 10.693Z",
  fill: "#159F9F"
});
function SvgEditIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconTable);
export default __webpack_public_path__ + "static/media/edit-icon-table.7ee349de.svg";
export { ForwardRef as ReactComponent };